import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { NgBsToastService } from 'ng-bs-toast-service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    selector: 'app-login',
    standalone: false,
    templateUrl: './login.component.html'
})
export class LoginComponent implements OnInit {

    loading: boolean;

    constructor(
        private authService: AuthService,
        private toastService: NgBsToastService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
    ) { }

    ngOnInit() {
        if (this.authService.token)
            this.router.navigate(['/consultations']);
    }

    onSubmit(form: NgForm) {
        this.loading = true;
        this.authService.loginForm(form.value).then(() => {
            this.loading = false;
            const url = this.activatedRoute.snapshot.queryParams['returnUrl'] || '/consultations';
            this.router.navigate([url]);
        }).catch((err: HttpErrorResponse) => {
            this.loading = false;
            this.toastService.send(`Error ${err.status}`, err.error.error || err.name, 'danger');
        });
    }
}